import { render, staticRenderFns } from "./YachHistory.vue?vue&type=template&id=502fba45"
import script from "./YachHistory.vue?vue&type=script&lang=js"
export * from "./YachHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports